import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      clearable: true,
      placeholder: '请选择部门'
    },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    },
    {
      field: 'fillDate',
      type: 'datepicker',
      label: '填报日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      label: '客户姓名',
      field: 'customerName',
      type: 'input',
      placeholder: '请输入客户姓名'
    },
    {
      label: '客户昵称',
      field: 'custNickName',
      type: 'input',
      placeholder: '请输入客户昵称'
    },
    {
      label: '开发账号',
      field: 'exploitAccount',
      type: 'input',
      placeholder: '请输入开发账号'
    },
    {
      label: '资金量',
      type: 'select',
      field: 'funds',
      clearable: true,
      placeholder: '请选择资金量',
      options: [
        { title: '<5万', value: 0 },
        { title: '5-10万', value: 1 },
        { title: '≥10万', value: 2 }
      ]
    },
    {
      label: '业绩核实结果',
      type: 'select',
      field: 'verifyResult',
      clearable: true,
      placeholder: '请选择业绩核实结果',
      options: [
        { title: '待填报', value: 'N' },
        { title: '待核实', value: 0 },
        { title: '属实', value: 1 },
        { title: '不属实', value: 2 }
      ]
    },
    {
      field: 'proveTeacher',
      type: 'select',
      label: '认可老师',
      clearable: true,
      placeholder: '请选择老师'
    },
    {
      field: 'openDate',
      type: 'datepicker',
      label: '开单日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
